module.exports = __webpack_public_path__ + "img/01.68dc47fe.jpg";